// extracted by mini-css-extract-plugin
module.exports = {"field":"dd31006766--field--Uvr8T","mobile":"dd31006766--mobile--Tkeyg","label":"dd31006766--label--XIbr3"};